import React from "react";
import { referenceLogos } from "../../mock";
import { useLanguage } from "../../contexts/LanguageContext";
import { t } from "../../i18n";

const ReferencesPage = () => {
    const { lang } = useLanguage();

    return (
        <div className="pt-[115px] sm:pt-[125px] bg-background pb-20 text-foreground min-h-screen">
            <div className="w-full max-w-[1900px] mx-auto px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6 pb-12">
                <header className="mb-6 md:mb-8 border-b border-black/10 pb-4 md:pb-6">
                    <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight uppercase text-primary">
                        {t(lang, "references.heading")}
                    </h1>
                    <p className="mt-2 text-muted-foreground text-sm">
                        {t(lang, "references.tagline")}
                    </p>
                </header>

                {/* Referans Görselleri / Panoları */}
                <div className="space-y-6 md:space-y-8 mb-10 md:mb-12">
                    <a
                        href="/profinoks/references/referans-1_1.jpeg"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block overflow-hidden rounded-xl bg-white p-2 sm:p-4 border border-black/10 shadow-sm hover:shadow-md transition-shadow cursor-zoom-in"
                        title="Tam boyutta görüntülemek için tıklayın"
                    >
                        <img
                            src="/profinoks/references/referans-1_1.jpeg"
                            alt="Profinoks Referanslar Projelendirme"
                            className="w-full h-auto object-contain rounded-lg"
                        />
                    </a>
                    <a
                        href="/profinoks/references/referans-2_1.jpeg"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block overflow-hidden rounded-xl bg-white p-2 sm:p-4 border border-black/10 shadow-sm hover:shadow-md transition-shadow cursor-zoom-in"
                        title="Tam boyutta görüntülemek için tıklayın"
                    >
                        <img
                            src="/profinoks/references/referans-2_1.jpeg"
                            alt="Profinoks Referans Logoları"
                            className="w-full h-auto object-contain rounded-lg"
                        />
                    </a>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-6">
                    {referenceLogos.map((logo, index) => (
                        <div
                            key={index}
                            className="flex h-36 sm:h-40 items-center justify-center rounded-lg bg-white p-4 sm:p-6 shadow-sm transition-transform hover:scale-105 border border-black/5"
                        >
                            <img
                                src={logo.image_url || logo}
                                alt={`Reference logo ${index + 1}`}
                                className="max-h-24 max-w-full object-contain"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ReferencesPage;
